export default __webpack_public_path__ + "static/media/frame-warchief.d1a34f82.png";